import { useEffect, useRef } from 'react'
import { CustomEventName, trackCustom } from '../utils/tracking'

/**
 * Fires a funnel event the first time a section is actually seen, so we can
 * measure conversion after each objection instead of only guessing at it.
 */
export function useTrackOnView<T extends HTMLElement>(event: CustomEventName, enabled = true) {
  const ref = useRef<T | null>(null)
  const fired = useRef(false)

  useEffect(() => {
    if (!enabled || fired.current) return
    const node = ref.current
    if (!node) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting) && !fired.current) {
          fired.current = true
          trackCustom(event)
          observer.disconnect()
        }
      },
      { threshold: 0.25 },
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [event, enabled])

  return ref
}
